module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [(_vm.isPendingView) ? _c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.pending_view')))]) : _c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.appointment_view')))]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "appointments-wrapper"
  }, [_c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.appointment.search_appointment')
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.paginator.from) + " - " + _vm._s(_vm.paginator.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.paginator.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.rows')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.prev_page_url && _vm.reloadAppointments(_vm.paginator.prev_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.next_page_url && _vm.reloadAppointments(_vm.paginator.next_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]), _vm._v(" "), (_vm.filtered_appointments.length > 0) ? _c('div', [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.filtered_appointments), function(app, index) {
    return _c('div', {
      key: index,
      staticClass: "appointment-container"
    }, [_c('div', {
      staticClass: "card appointment-content"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('span', {
      staticClass: "app-date"
    }, [_vm._v(_vm._s(app.start))]), _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(app.object.status))])]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('h6', {
      staticClass: "app-name"
    }, [_vm._v(_vm._s(app.object.firstname) + " " + _vm._s(app.object.lastname))]), _vm._v(" "), _c('div', {
      staticClass: "app-phone"
    }, [_vm._v(_vm._s(app.object.phone))]), _vm._v(" "), _c('div', {
      staticClass: "app-doctor"
    }, [_vm._v(_vm._s(app.title))])])])])
  }))], 1) : _c('h6', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.appointment.no_appointment')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('div', {
    staticClass: "appointment-form"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.appointment.add_appointment')))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fp"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.appointment.appointment_date')))])]), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": {
        enableTime: true,
        altInput: true,
        wrap: true,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.appointment.appointment_time),
      callback: function($$v) {
        _vm.appointment.appointment_time = $$v
      },
      expression: "appointment.appointment_time"
    }
  }), _c('br'), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.appointment.firstname'),
      "placeholder": _vm.$t('message.appointment.firstname')
    },
    model: {
      value: (_vm.appointment.firstname),
      callback: function($$v) {
        _vm.appointment.firstname = $$v
      },
      expression: "appointment.firstname"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.appointment.lastname'),
      "placeholder": _vm.$t('message.appointment.lastname')
    },
    model: {
      value: (_vm.appointment.lastname),
      callback: function($$v) {
        _vm.appointment.lastname = $$v
      },
      expression: "appointment.lastname"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.appointment.phone'),
      "placeholder": _vm.$t('message.appointment.phone')
    },
    model: {
      value: (_vm.appointment.phone),
      callback: function($$v) {
        _vm.appointment.phone = $$v
      },
      expression: "appointment.phone"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.appointment.email'),
      "placeholder": _vm.$t('message.appointment.email')
    },
    model: {
      value: (_vm.appointment.email),
      callback: function($$v) {
        _vm.appointment.email = $$v
      },
      expression: "appointment.email"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.duration')))]), _vm._v(" "), _c('bs-input', {
    staticClass: "input-min",
    attrs: {
      "type": "Number",
      "min": "1",
      "max": "59",
      "placeholder": _vm.$t('message.appointment.duration')
    },
    model: {
      value: (_vm.appointment.duration),
      callback: function($$v) {
        _vm.appointment.duration = $$v
      },
      expression: "appointment.duration"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.appointment.duration_unit')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.service')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "service",
      "placeholder": _vm.$t('message.appointment.service_placeholder'),
      "options": [{
        label: 'service',
        value: '1'
      }],
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.service),
      callback: function($$v) {
        _vm.appointment.service = $$v
      },
      expression: "appointment.service"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.doctor')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": _vm.$t('message.appointment.doctor'),
      "options": [{
        label: 'doctor1',
        value: '1'
      }],
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.doctor),
      callback: function($$v) {
        _vm.appointment.doctor = $$v
      },
      expression: "appointment.doctor"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": _vm.$t('message.appointment.addition'),
      "placeholder": _vm.$t('message.appointment.addition')
    },
    model: {
      value: (_vm.appointment.comment),
      callback: function($$v) {
        _vm.appointment.comment = $$v
      },
      expression: "appointment.comment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.cancelAddingAppointment
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addAppointment
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-action",
    on: {
      "click": _vm.removeAppointment
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))])])]) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2611d9aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/appointment/Appointment.vue
// module id = 991
// module chunks = 1